import React from 'react';
import { Download, ExternalLink, Briefcase, Search, ArrowRight, Trophy, FileText, Sparkles, Star, Mail } from 'lucide-react';
import profile3 from "../assets/images/profile3.jpg";
import Tuner from '../assets/images/Tuner.png'
// import Replio from '../assets/images/replio.png'
import ChatGPTProTools from '../assets/images/chatgptprotools.png'
const Portfolio = ({ onNavigate }) => {

  // Sample project data for featured projects on home page
  const featuredProjects = [
    // {
    //   id: "Replio",
    //   title: "Replio",
    //   category: "AI Productivity",
    //   description: "An intelligent email assistant application designed to streamline your email management using AI.",
    //   tags: ["Python", "React", "FastAPI"],
    //   imageUrl: Replio,
    //   github: "https://github.com/bhimamalbhage/digital-twin",
    // },
    {
          id: "chatgptprotools",
          title: "ChatGPT Pro Tools",
          description: "A premium Chrome extension that enhances your AI chat experience (ChatGPT, Claude, Gemini) with powerful productivity features and beautiful themes.",
          longDescription: "ChatGPT Pro Tools is a premium Chrome extension designed to elevate your AI chat experience. It seamlessly integrates with ChatGPT, Claude, and Gemini, offering a suite of powerful productivity features and beautiful themes to enhance your workflow.",
          tags: ["Astro", "TailwindCSS"],
          imageUrl: ChatGPTProTools,
          github: "https://github.com/bhimamalbhage/chatgpt-pro-tools",
          demo: "http://www.chatgptprotool.com/",
    },
    {
      id: "tuner",
      title: "Tuner",
      category: "Robotics Platform",
      description: "Democratizing advanced robotics by enabling anyone to fine-tune general-purpose robots.",
      tags: ["Python", "React", "Typescript"],
      imageUrl: Tuner,
      github: "https://github.com/clemens-chr/tuner",
    },
  ];

  return (
    <div className="max-w-5xl mx-auto p-8 md:p-12 relative font-sans text-gray-900">
      
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row items-center gap-12 mb-20 animate-in fade-in slide-in-from-bottom-4 duration-700">
        <div className="relative group">
           <div className="absolute -inset-1 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full blur opacity-20 group-hover:opacity-40 transition duration-1000"></div>
          <img
            src={profile3}
            alt="Profile"
            className="relative w-40 h-40 md:w-48 md:h-48 rounded-full object-cover shadow-2xl ring-4 ring-white"
          />
        </div>

        <div className="text-center md:text-left flex-1">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4 bg-clip-text text-transparent bg-gradient-to-br from-gray-900 to-gray-600">
            Hey, I'm Bhima <span className="inline-block animate-bounce opacity-70" style={{ WebkitTextFillColor: 'initial', color: 'inherit' }}>🚀</span>
          </h1>
          
          <div className="space-y-4 text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl">
            <p>
              I am a <span className="font-semibold text-gray-900 border-b-2 border-blue-500/30">builder</span> and <span className="font-semibold text-gray-900 border-b-2 border-purple-500/30">full stack engineer</span>.
            </p>
            <p className="items-center gap-2 inline-flex">
              I love solving 
              <span className="bg-gray-100 text-gray-900 px-2 py-0.5 rounded-md font-medium text-base shadow-sm border border-gray-200">
                deep technical problems
              </span>
            </p>
          </div>

          <div className="mt-8 flex flex-wrap gap-4 justify-center md:justify-start">
            <a
              href="https://drive.google.com/file/d/1mxb8qrbPohElw7xwAHutd2NIgy0K14Gc/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-full bg-gray-900 text-white font-medium hover:bg-gray-800 transition-all flex items-center gap-2 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              <Download className="w-4 h-4" />
              <span>Resume</span>
            </a>
            
            <a 
              href="mailto:bhimamalbhage1008@gmail.com"
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = "mailto:bhimamalbhage1008@gmail.com";
              }}
              className="px-5 py-2.5 rounded-full bg-white text-gray-900 font-medium hover:bg-gray-50 transition-all flex items-center gap-2 shadow-lg hover:shadow-xl hover:-translate-y-0.5 border border-gray-200"
            >
              <Mail className="w-4 h-4 text-blue-600" />
              <span>Contact</span>
            </a>
          </div>
        </div>
      </div>

      {/* Highlights Section */}
      <div className="mb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
          <Star className="w-6 h-6 text-yellow-600" /> Highlights
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Hackathon Winner */}
          <div className="glass p-6 rounded-2xl border border-transparent hover:border-yellow-200/50 transition-all duration-300 group">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <Trophy className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 mb-1">5x Hackathon Winner</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Including Stanford Hackathon 2025
                </p>
              </div>
            </div>
          </div>

          {/* IEEE Publication */}
          <a 
            href="https://ieeexplore.ieee.org/document/10993978"
            target="_blank"
            rel="noopener noreferrer"
            className="glass p-6 rounded-2xl border border-transparent hover:border-blue-200/50 transition-all duration-300 group cursor-pointer block"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <FileText className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 mb-1 flex items-center gap-2">
                  IEEE Published
                  <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors" />
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Research paper on AI-powered traffic analysis
                </p>
              </div>
            </div>
          </a>

          {/* AI Products */}
          <div className="glass p-6 rounded-2xl border border-transparent hover:border-purple-200/50 transition-all duration-300 group">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 mb-1">AI Product Builder</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Building and shipping AI-native products
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid Layout for Status and Featured */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-12">
          {/* Status Card - Spans 1 column */}
          <div className="glass p-6 rounded-2xl flex flex-col justify-between h-full">
             <div>
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                        <Search className="w-5 h-5 text-green-600" />
                    </div>
                    <div>
                         <h3 className="font-semibold text-gray-900">Job Status</h3>
                         <p className="text-sm text-gray-500">Open to opportunities</p>
                    </div>
                </div>
                
                <div className="space-y-4">
                    <div className="flex items-start gap-3">
                         <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-2"></div>
                         <div>
                             <p className="text-sm font-medium text-gray-900">Ex-Deloitte</p>
                             <p className="text-xs text-gray-500">Software Engineer (2021-2023)</p>
                         </div>
                    </div>
                    <div className="flex items-start gap-3">
                         <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 animate-pulse"></div>
                         <div>
                             <p className="text-sm font-medium text-gray-900">Seeking Full-time</p>
                             <p className="text-xs text-gray-500">Backend / Full Stack</p>
                         </div>
                    </div>
                </div>
             </div>

             <div className="mt-6 pt-6 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                      <Briefcase className="w-4 h-4" />
                      <span>3+ Years Experience</span>
                  </div>
             </div>
          </div>

          {/* Featured Projects - Spans 2 columns */}
          <div className="lg:col-span-2 space-y-6">
             <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Featured Work</h2>
                <button
                    onClick={() => onNavigate && onNavigate('projects')}
                    className="text-sm font-medium text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors"
                >
                    View All <ArrowRight className="w-4 h-4" />
                </button>
             </div>

             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {featuredProjects.map((project) => (
                    <div
                    key={project.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      onNavigate && onNavigate('projects');
                    }}
                    className="glass p-4 rounded-2xl group cursor-pointer hover:shadow-saas-hover transition-all duration-300 border border-transparent hover:border-gray-200/50"
                    >
                        <div className="aspect-video w-full rounded-xl overflow-hidden bg-gray-100 mb-4 shadow-inner relative">
                             <img
                                src={project.imageUrl}
                                alt={project.title}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                        
                        <div className="space-y-2">
                             <div className="flex justify-between items-start">
                                 <div>
                                     <h3 className="font-semibold text-gray-900">{project.title}</h3>
                                     <p className="text-xs font-medium text-blue-600 uppercase tracking-wide">{project.category}</p>
                                 </div>
                                 <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-gray-600" />
                             </div>
                             <p className="text-sm text-gray-600 line-clamp-2 leading-relaxed">
                                 {project.description}
                             </p>
                        </div>
                    </div>
                ))}
             </div>
          </div>
      </div>
      
    </div>
  );
};

export default Portfolio;

